import { Injectable, OnInit } from '@angular/core';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthFacadeService } from './auth-facade.service';
import { PharmacyFacadeService } from './pharmacy-facade.service';
import { FeaturesService } from '../proxy/skybound/sky-gen1/features';
import { firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild, OnInit
{
	constructor(
		private router: Router,
		private authFacadeService: AuthFacadeService,
		private pharmacyFacadeService: PharmacyFacadeService,
		private featuresService: FeaturesService
	) { }

	ngOnInit(): void
	{
	}

	async canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Promise<boolean | UrlTree>
	{
		console.debug('AuthGuardService: canActivate called for route:', next.routeConfig?.path);
		const loggedIn = await this.authFacadeService.hasLoggedIn(false);
		console.debug('AuthGuardService: canActivate called, loggedIn:', loggedIn);
		if (!loggedIn) {
			console.debug('User not logged in, clearing current pharmacy profile');
			this.pharmacyFacadeService.setCurrentPharmacyProfile(null, false);
		}
		return loggedIn ? true : this.router.parseUrl('/auth/welcome');
	}

	async canActivateChild(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Promise<boolean | UrlTree>
	{
		console.debug('AuthGuardService: canActivateChild called for route:', next.routeConfig?.path);
		const loggedIn = await this.authFacadeService.hasLoggedIn(false);
		console.debug('AuthGuardService: canActivateChild called, loggedIn:', loggedIn);
		if (!loggedIn) {
			console.debug('User not logged in, clearing current pharmacy profile');
			this.pharmacyFacadeService.setCurrentPharmacyProfile(null, false);
		}
		return loggedIn ? true : this.router.parseUrl('/auth/welcome');
	}
}
